'use client';

import { useIntl } from 'react-intl';
import { EfficiencyFlagOverlayDialog } from '../../components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import {
  TireEfficiencyFlagLocalized,
  type TireEfficiencyFlagLocalizedProps,
} from '../../components/TireEfficiencyFlagLocalized/TireEfficiencyFlagLocalized.client';
import { tireEfficiencyFlagMessages } from '../../messages';

/**
 * Props for rendering a localized tire efficiency flag item with overlay support.
 */
export type TireEfficiencyFlagItemProps = {
  linkToEnergieEfficiencyLabel: string;
  text: TireEfficiencyFlagLocalizedProps['text'];
  type: TireEfficiencyFlagLocalizedProps['type'];
  size?: TireEfficiencyFlagLocalizedProps['size'];
};

/**
 * Renders a tire efficiency flag that opens the referenced efficiency label image in an overlay dialog.
 */
export const TireEfficiencyFlagItem = ({
  linkToEnergieEfficiencyLabel,
  size,
  text,
  type,
}: TireEfficiencyFlagItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <EfficiencyFlagOverlayDialog
      overlay={{
        title: formatMessage(tireEfficiencyFlagMessages[type]),
        imgUrl: linkToEnergieEfficiencyLabel,
      }}
    >
      <TireEfficiencyFlagLocalized type={type} text={text} size={size} />
    </EfficiencyFlagOverlayDialog>
  );
};
